import { render } from "./UserSupport.vue?vue&type=template&id=a79785bc"
import script from "./UserSupport.vue?vue&type=script&lang=js"
export * from "./UserSupport.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__